<template>
  <vl-modal :id="modalId" :title="title" :closable="closable" :open="open" :modLarge="modLarge">
    <component :is="content.component" v-bind="content.props"></component>
  </vl-modal>
</template>
<script lang="ts" setup>
import { useModalStore } from '@/modules/core/store/modal.store';
import { computed, onMounted, onUnmounted, reactive, watch } from 'vue';

const store = useModalStore();
const modalId = 'pbs-modal';

const open = computed(() => {
  return store.open;
});

const closable = computed(() => {
  if (store.content) {
    return store.content?.closable;
  }
  return true;
});

const content = computed(() => {
  return store.content;
});

const title = computed(() => {
  return content.value?.title;
});

const modLarge = computed(() => {
  return content.value?.modLarge;
});

const closedHandler = (evt: any) => {
  if (evt.detail.modalId !== modalId) {
    return;
  }

  store.hideModal();
};

onMounted(() => {
  document.addEventListener('closed', closedHandler);
});

onUnmounted(() => {
  document.removeEventListener('closed', closedHandler);
});
</script>
<style lang="scss" scoped></style>
